import * as Yup from 'yup';

export default Yup.object().shape({
  role: Yup.string().required('Campo obrigatório'),
});
